import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { Dummyable, AppConfigService } from '@eucoms/common-components';

import { environment } from '@environments/environment';
import { JSONTabularData } from './table/tabular-data.interface';
import { factoryDummyData } from './dummy-data';

@Injectable()
export class DataSourceService {
  static http: HttpClient;

  constructor(
    http: HttpClient,
    private appConfig: AppConfigService
    ) {
    DataSourceService.http = http;
  }

  // static parseData(payload: any, endpoint: DataEndpoint) {
  //   switch (endpoint) {
  //     case DataEndpoint.ComedByCounty:
  //       return this.parseCsv(payload as ArrayBuffer);
  //     case DataEndpoint.ComedByChicagoWards:
  //       return this.parseCsv(payload as ArrayBuffer);
  //     case DataEndpoint.ComedByCityTownVillage:
  //       return this.parseCsv(payload as ArrayBuffer);
  //   }
  //   return [];
  // }

  // static parseCsv(payload: ArrayBuffer) {
  //   const data = new TextDecoder('utf-8').decode(payload);
  //   return data.split(/\r?\n|\r/).map(line => line.split(/\s*,\s*/));
  // }

  @Dummyable({
    override: environment.devEnvironment,
    factoryResponse: factoryDummyData(DataSourceService as any)
  })

  get(endpoint: string) {
    // eslint-disable-next-line max-len
    return DataSourceService.http.get<Array<JSONTabularData>>(this.appConfig.config.fallbackMapDataUrl + endpoint ).pipe(
      // map(res => DataSourceService.parseData(res, endpoint)),
      catchError(err => {
        console.warn('error connecting to endpoint', endpoint);
        return of([]);
      }));
  }

  getACEMoreInfo() {
    const endpoint = '/ace/info';

    return DataSourceService.http.get<Array<JSONTabularData>>(this.appConfig.config.fallbackMapDataUrl + endpoint ).pipe(
      catchError(err => {
        console.warn('error connecting to endpoint', endpoint);
        return of([]);
      }));
  }
}
